/*
 * Module for the Available Work Monitor job criteria page
 */
rs.module("content/jobs/criteria/benefitstatuschange", 

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the page
        function initialize(jsSelectors, codeValues, lrsGridApi, backendUrl) {
            var criteria = $.js(jsSelectors.criteria);
            var currentStatusSelect = criteria.js(jsSelectors.currentStatusSelect);
            var newStatusLabel = criteria.js(jsSelectors.newStatusLabel);
            var loadingSpinner = criteria.js(jsSelectors.loadingSpinner);

            // update the grid when the status is changed
            currentStatusSelect.change(function () {
                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { currentStatus: currentStatusSelect.val() },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        loadingSpinner.hide();
                    }
                );

                if (currentStatusSelect.val() == codeValues.active) {
                    newStatusLabel.text("Pending");
                } else if (currentStatusSelect.val() == codeValues.pending) {
                    newStatusLabel.text("Active");
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);